(function(){
var d=document.documentElement,reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
document.addEventListener('click',function(e){
  if(e.target.closest('[data-burger]')){document.querySelector('[data-nav]').classList.toggle('open')}
  if(e.target.closest('[data-nav] a')){document.querySelector('[data-nav]').classList.remove('open')}
  var t=e.target.closest('[data-thumb]');if(t){document.querySelector('[data-main]').src=t.dataset.thumb}
});
document.addEventListener('submit',function(e){
  if(e.target.matches('[data-finder]')){e.target.querySelectorAll('select').forEach(function(s){if(!s.value)s.disabled=true})}
});
document.addEventListener('change',function(e){
  var f=e.target.closest('[data-autosubmit]');if(f){f.submit()}
  if(e.target.matches('[data-variant]')){
    var o=e.target.selectedOptions[0],p=document.querySelector('[data-price]');if(p)p.textContent=o.dataset.price;
    var b=document.querySelector('[data-add]');if(b){b.disabled=o.dataset.available!=='true';b.textContent=b.disabled?'Rasprodano':'Dodaj u košaricu'}
  }
});
/* header + parallax */
var hd=document.querySelector('[data-hd]'),par=[].slice.call(document.querySelectorAll('[data-parallax]')),tick=false;
function onScroll(){
  if(hd)hd.classList.toggle('scrolled',window.scrollY>40);
  if(!reduce)par.forEach(function(el){var r=el.parentNode.getBoundingClientRect();if(r.bottom>0&&r.top<innerHeight){el.style.transform='translate3d(0,'+(-r.top*0.18).toFixed(1)+'px,0)'}});
  tick=false;
}
addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(onScroll)}},{passive:true});onScroll();
/* reveal + loading state */
document.querySelectorAll('.sec>.wrap,.ft-g,.help-in').forEach(function(el){el.classList.add('rv')});
var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.1});
document.querySelectorAll('.rv').forEach(function(el){io.observe(el)});
document.querySelectorAll('.card-img img,.cat-img img,.about-img img').forEach(function(img){
  var p=img.parentNode;function ok(){p.classList.add('ld')}
  if(img.complete&&img.naturalWidth)ok();else img.addEventListener('load',ok)
});
/* cinematic intro */
var el=document.querySelector('[data-intro]');if(!el)return;
if(!d.classList.contains('intro-pending')){el.remove();return}
d.classList.add('lock');
var v=el.querySelector('[data-ivideo]'),a=el.querySelector('[data-iaudio]'),timers=[],done=false;
function T(f,ms){timers.push(setTimeout(f,ms))}
function finish(){
  if(done)return;done=true;timers.forEach(clearTimeout);
  try{sessionStorage.setItem('af_intro','1')}catch(e){}
  if(a)a.pause();
  el.classList.add('open');d.classList.add('reveal');
  setTimeout(function(){el.remove();d.classList.remove('lock','intro-pending')},1150);
}
if(reduce){T(finish,300)}else{
  requestAnimationFrame(function(){el.classList.add('go')});
  if(v){var p=v.play();if(p&&p.catch)p.catch(function(){})}
  T(function(){el.classList.add('zoom')},v?3900:2600);
  T(finish,v?4800:4000);
  T(finish,7000);
}
var sk=el.querySelector('[data-skip]');if(sk)sk.addEventListener('click',finish);
var sn=el.querySelector('[data-sound]');if(sn&&a)sn.addEventListener('click',function(){a.currentTime=0;a.play();sn.remove()});
})();
